import React, { useState, useReducer, useEffect, useContext } from "react";
import { Alert,  Table,  Button } from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import queryString from 'query-string'
import moduleConfig from "./moduleConfig"
import axios from "../../../config/axios";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";
import useConfirm from "../../../HOC/custom/useConfirm";
import ListingFooter from "./partials/listing/ListingFooter";
import SearchArea from "./partials/listing/SearchArea";
import { listingReducer, listingInitialState } from "./reducers/listingReducer";


const PollSubmissionListing = () => {
  let { id } = useParams();

  const { setBreadcrumb } = useContext(BreadcrumbContext);
  const [listingState, listingDispatch] = useReducer(listingReducer, listingInitialState)
  const [isCheck, setIsCheck] = useState([]);
  const [isCheckAll, setIsCheckAll] = useState(false);

  const { search } = useLocation();
  const [appliedFilters, setAppliedFilters] = useState(queryString.parse(search))
  if (appliedFilters.limit) {
    moduleConfig.perPageItems = appliedFilters.limit;
  }

  let breadcrumbs = {
    pollListing: {
      label: "Polls",
      url: `/polls`,
    },
    pollDetails: {
      label: "Poll Details",
      url: `/polls/${id}`,
    },
    pollSubmissionListing: {
      label: 'Submissions',

    },
  };

  let history = useNavigate()

  const setFilter = (name, value) => {
    console.log(`setFilter called with ${name}, ${value}`)
    let newAppliedFilters = JSON.parse(JSON.stringify(appliedFilters));

    if (value) {
      newAppliedFilters[name] = value;
    } else {
      delete newAppliedFilters[name]
    }

    if (name !== 'page') {
      delete newAppliedFilters['page'];
    }

    if (name === 'limit' || name === 'page') {
      setIsCheck([]);
      setIsCheckAll(false)
    }

    let newURL = queryString.stringify(newAppliedFilters);
    history({ search: newURL });
    setAppliedFilters(newAppliedFilters)
  }

  const loadItems = async () => {
    listingDispatch({
      type: "FETCH_REQUEST"
    });
    try {
      const res = await axios.get(`poll-submissions/${id}${search}`)//
      listingDispatch({
        type: "FETCH_SUCCESS",
        payload: res.data
      });
    } catch (error) {
      listingDispatch({
        type: "FETCH_FAILURE",
        payload: error
      });
    }
  }

  const resetFilters = () => {
    //console.log(`resetFilters called`)
    let newAppliedFilters = JSON.parse(JSON.stringify(appliedFilters));

    moduleConfig.perPageItems = 10;
    delete newAppliedFilters['limit'];
    delete newAppliedFilters['status']
    delete newAppliedFilters['q']
    delete newAppliedFilters['purpose']
    delete newAppliedFilters['type']

    let newURL = queryString.stringify(newAppliedFilters);
    history({ search: newURL });
    //console.log(newAppliedFilters);
    setAppliedFilters(newAppliedFilters)
  }

  useEffect(() => {
    loadItems();
  }, [search])


  useEffect(() => {
    setBreadcrumb([
      breadcrumbs.pollListing,
      breadcrumbs.pollDetails,
      breadcrumbs.pollSubmissionListing,
    ]);
  }, [])


  return (<DashboardLayout >
    {(listingState.isLoading)
      && <ContainerLoading />
    }

    {
      (listingState.status !== 'fetching') &&
      <>

        {(listingState.error && listingState.status === 'fetchFailed')
          ? <BlockErrorMessage error={listingState.error} />
          : <>

            <ModuleHeader
              moduleTitle={moduleConfig.title}
              moduleUrl={moduleConfig.url}
            ></ModuleHeader>

            <div className="listingPage">

              {(listingState.data && listingState.data.pagination && listingState.data.pagination.totalItems > 0)
                ? <>
                  {/* Search Area */}
                  <SearchArea
                    moduleConfig={moduleConfig}
                    setFilter={setFilter}
                    appliedFilters={appliedFilters}
                    resetFilters={resetFilters}
                  />


                  {/* Listing */}
                  <section className="content listing">

                    {
                      (listingState.error)
                      && <FormErrorMessage error={listingState.error} />
                    }






                    {(!listingState.data.items || listingState.data.items.length <= 0)
                      ? <Alert variant="warning" >No records found with selected filters. <Alert.Link href="#" onClick={() => resetFilters()}><i className="fas fa-times" /> Reset Filters</Alert.Link>.</Alert>
                      :
                      <>
                        {(listingState.data.items && listingState.data.items.length) && (
                          <>

                            <div className="registrationTable overflow-auto m-0 p-0 mt-2">
                              <Table striped bordered hover size="sm">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Member</th>
                                    <th>Question Submission Count</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>

                                  {
                                    listingState.data.items.map((item, index) => {
                                      return <tr index={index}>

                                        <td>{index + 1}</td>
                                        <td><Button href={`/members/${item._id}`} variant="link">{item.fullName}</Button></td>
                                        <td>{item.submissionsCount}</td>

                                        <td className={`text-center record-actions  MoreItem`}>
                                          <Link to={`/poll-submissions/details/${id}/${item._id}`} className="btn btn-outline-secondary btn-sm" >
                                            <i className="fas fa-eye">
                                            </i>
                                          </Link>
                                        </td>
                                      </tr>
                                    })
                                  }
                                </tbody>
                              </Table>
                            </div>
                          </>
                        )}
                      </>
                    }
                  </section>

                  <ListingFooter
                    listingState={listingState}
                    moduleConfig={moduleConfig}
                    setFilter={setFilter}
                  />
                </>
                : <Alert variant="warning" >No records found.</Alert>
              }
            </div>
          </>
        }
      </>

    }


  </DashboardLayout >);
}

export default PollSubmissionListing;
